module.exports = __webpack_public_path__ + "static/media/close-side.2861fb57.svg";